import React from "react";
import cx from "classnames";

type Props = {
  label: string;
  checkboxStyle?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Checkbox: React.FC<Props> = ({
  label,
  className,
  defaultChecked,
  onChange,
  checkboxStyle,
}): JSX.Element => {
  return (
    <div className="flex flex-row">
      <input
        type="checkbox"
        className={cx("mr-2 my-auto", checkboxStyle)}
        defaultChecked={defaultChecked}
        onChange={onChange}
      />
      <span className={cx("font-nunito", className)}>{label}</span>
    </div>
  );
};

export default Checkbox;
